module.exports = __webpack_public_path__ + "static/img/基于红外热释感应测试植物温度的装置.18c631a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/基于红外热释感应测试植物温度的装置.jpg
// module id = IG+R
// module chunks = 15